module.exports = __webpack_public_path__ + "img/success-message.a9e6d835.svg";